<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <form @submit.prevent="submitFunction">
        <div class="join container">
          <div class="joinContext">
            <div class="userInfo" >
              <div class="profile">
                <img src="../../assets/images/user.png" />
                <p> {{GET_USERINFO_LIST.userName}}님 환영합니다.</p>
              </div>
              <div class="article">
                <div class="caption">이름</div>
                <p>{{GET_USERINFO_LIST.userName}}</p>
              </div>
              <div class="article">
                <div class="caption">성별</div>
                <p v-text="form.gender.value"></p>
              </div>
              <div class="article">
                <div class="caption">차트번호</div>

                <p v-text="form.chartNumber.value"></p>
              </div>
              <div class="article">
                <div class="caption">생년월일</div>
                <p>{{GET_USERINFO_LIST.birthDate | formatBirth}}</p>
              </div>
              <div class="article">
                <div class="caption">아이디</div>
                <p>{{GET_USERINFO_LIST.id}}</p>
              </div>
              <div class="article withButton">
                <div class="caption">휴대폰번호</div>
                <p>{{form.tel.value | formatPhone}}</p>
                <form method="post" name="form_chk">
                  <!-- 요청모드 (필수 데이터) -->
                  <input type="hidden" name="m" value="checkplusSerivce">
                  <!-- 업체정보 암호화 데이터 -->
                  <input type="hidden" name="EncodeData" :value="this.getIdentity">
                  <button type="button" class="miniBtn" @click="fnPopup()" v-if="isCertificated">변경</button>
                </form>
              </div>
              <div class="article">
                <div class="caption">이메일</div>
                <p>{{GET_USERINFO_LIST.mail}}</p>
              </div>
              <div class="article raw">
                <div class="caption">이메일 변경</div>
                <input v-model="form.mail.value" maxlength="22" @keyup="blurMail()" class="mailInput" id="mailInput"/>
              </div>
            </div>
          <!--  <div class="separateEmailWrap">
            <div class="article require">
              <div class="inputHeader">
                <p>이메일</p>
                <span class="warn"
                      v-if="form.mail.hasError" v-text="form.mail.errorTxt"></span>
              </div>
              <input  type="text" v-model="form.mail.value" maxlength="21" @blur="blurMail()"/>
            </div>
            </div>-->
            <span class="warn" v-if="form.mail.hasError" v-text="form.mail.errorTxt"></span>
          </div>
        </div>
        <div class="btnWrap" :class="{visible : form.mail.flag }">
          <button type="submit" >회원정보 변경</button>
        </div>
      </form>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>
<script>
import AppSidebar from '../../components/AppSidebar'
import AppHeader from '../../components/AppHeader'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { getCookie } from '@/utils/cookieNew'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single',
        nextLink: '',
        closeType: 'close'
      },
      transDate: {
        headerName: '회원정보 변경',
        prevUrl: '/controllSetting'
      },
      form: {
        tel: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        mail: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        chartNumber: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        gender: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.',
          data: ''
        }
      },
      errorMessage: false,
      view: {
        mutatedGender: false,
        chartNumNullable: false,
        tSample: '',
        carryError: '비밀번호를 다시 인증해주세요.'
      },
      isCertificated: false,
      setCount: false
    }
  },
  created () {
    /* url 직접 접근 막기 */
    if (this.getReferrer.includes('confirmPasswordInfo') !== true) {
      this.SET_POPUP(true)
      this.popupSet.content = '잘못된 접근입니다.'
      this.popupSet.count = 'another'
      this.popupSet.nextLink = '/'
      this.popupSet.closeType = 'action'
      this.popupSet.closeLink = '/'
    }
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    this.$nextTick(_ => {
      const url = document.location.href
      console.log('url: ', url)
      this.SET_URL(url)
      localStorage.setItem('url', url)
    })
    this.fetchData()
    this.checkInfo()
  },
  computed: {
    ...mapState([
      'checkPopup'
    ]),
    ...mapGetters([
      'GET_USERINFO_LIST',
      'getIdentity',
      'getFailIdentity'
    ]),
    ...mapGetters('referrer', [
      'getReferrer'
    ]),
    ...mapGetters('identity', [
      'getSuccess',
      'getIsTemp'
    ])
  },
  methods: {
    ...mapMutations('referrer', [
      'SET_REFERRER'
    ]),
    checkInfo () {
      const getValue = this.$store.getters.GET_CHECKED_PW
      if (!getValue) {
        this.SET_POPUP(true)
        this.popupSet.content = '다시 진행해주세요.'
        this.popupSet.count = 'another'
        this.popupSet.nextLink = '/modifyUser/confirmPasswordInfo'
        this.popupSet.closeType = 'action'
        this.popupSet.closeLink = '/modifyUser/confirmPasswordInfo'
      } else {
        console.log('비밀번호 체크하고 진입함')
      }
    },
    callPrev () {
      if (this.setCount) {
        this.$router.push('/modifyUser/confirmPasswordInfo')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    },
    blurMail () {
      this.form.mail.flag = false
      this.checkMail()
    },
    checkMail () {
      if (this.form.mail.flag) return true
      const mail = this.form.mail.value
      console.log('mail: ', mail)
      if (mail === '') {
        this.form.mail.hasError = true
        this.form.mail.errorTxt = '이메일을 입력해주세요.'
        return false
      }
      // eslint-disable-next-line no-useless-escape
     const isMail = /^[0-9a-zA-Z ]([-_\.]?[0-9a-zA-Z ])*@[0-9a-zA-Z ]([-_\.]?[0-9a-zA-Z ])*\.[a-zA-Z ]{2,3}$/i
      if (!isMail.test(mail)) {
        this.form.mail.hasError = true
        this.form.mail.errorTxt = '이메일 형식에 맞지 않습니다.'
        this.form.mail.flag = false
        return false
      }
      this.form.mail.flag = true
      this.form.mail.hasError = false
      this.form.mail.errorTxt = ''
      return true
    },
    async fetchData () {
      try {
        this.FETCH_USER_DATA()
          .then(() => this.carryData())
      } catch (error) {
        console.log('error :', error);
        console.log('유저정보 불러오기 에러에 진입함!')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          this.popupSet.content = errorParser.parse(error)
        } else {
          await this.$router.push('/login')
        }
      }
    },
    carryData () {
      const userData = {
        id: getCookie('userId'),
        mail: this.GET_USERINFO_LIST.mail
      }
      this.IS_TEMP(userData)
        .then(() => {
          if (this.getIsTemp.isCertificated === true) {
            this.isCertificated = true
          } else {
            this.isCertificated = false
          }
        })
      console.log('데이터 tel', this.GET_USERINFO_LIST.tel)
      console.log('데이터 차트번호', this.GET_USERINFO_LIST.chartNumber)
      console.log('데이터 성별', this.GET_USERINFO_LIST.gender)
      console.log('데이터 이메일', this.GET_USERINFO_LIST.mail)
      console.log('데이터 아이디', this.GET_USERINFO_LIST.id)
      console.log('데이터 생년월일', this.GET_USERINFO_LIST.birthDate)

      /* 본인인증 후 기존 정보와 본인인증 데이터가 일치하지 않는다면 튕김 */
      if (this.getSuccess.birthDate !== '' || this.getSuccess.dupInfo !== '' || this.getSuccess.gender !== '' || this.getSuccess.mobileno !== '' || this.getSuccess.name !== '') {
        this.form.tel.value = this.getSuccess.mobileno

        if (this.getSuccess.gender === '0') {
          this.form.gender.data = 'F'
        } else if (this.getSuccess.gender === '1') {
          this.form.gender.data = 'M'
        }
        if (this.GET_USERINFO_LIST.userName !== this.getSuccess.name ||
          this.GET_USERINFO_LIST.gender !== this.form.gender.data ||
          this.GET_USERINFO_LIST.birthDate.replace(/[^0-9]/g, '') !== this.getSuccess.birthDate) {
          this.SET_POPUP(true)
          this.popupSet.count = 'another'
          this.popupSet.closeType = 'action'
          this.popupSet.closeLink = '/'
          this.popupSet.nextLink = '/'
          this.popupSet.content = '본인인증 정보와 기존 정보가 일치하지 않습니다. 정보를 확인해주세요.'
          /* 본인인증 정보 초기화 */
          const userInfo = {
            name: '',
            birthDate: '',
            gender: '',
            mobileno: '',
            dupInfo: ''
          }
          this.SET_IDENTITY_SUCCESS(userInfo)
          return false
        }
      } else {
        const num = this.GET_USERINFO_LIST.tel
        this.form.tel.value = num
      }
      if (this.GET_USERINFO_LIST.chartNumber == null) {
        this.form.chartNumber.value = '차트번호가 없습니다.'
      } else {
        this.form.chartNumber.value = this.GET_USERINFO_LIST.chartNumber
      }
      if (this.GET_USERINFO_LIST.gender === 'M') {
        console.log('진입함 남성')
        this.form.gender.value = '남성'
      } else if (this.GET_USERINFO_LIST.gender === 'F') {
        console.log('진입함 여성')
        this.form.gender.value = '여성'
      }
    },
    submitFunction () {
      if (this.form.mail.flag) {
        this.changeUserInfo()
      } else {
        this.popupSet.content = '이메일 정보를 확인해주세요.'
        this.SET_POPUP(true)
      }
    },
    async changeUserInfo () {
      this.form.tel.value = this.formatPhoneNumber(this.form.tel.value)
      console.log('tel:: ', this.form.tel.value)
      try {
        const userData = {
          tel: this.form.tel.value,
          mail: this.form.mail.value.replace(/\s/gi, '')
        }
        await this.MODIFY_USER_DATA(userData)
          .then(() => {
            /* 본인인증 정보 초기화 */
            const userInfo = {
              name: '',
              birthDate: '',
              gender: '',
              mobileno: '',
              dupInfo: ''
            }
            this.SET_IDENTITY_SUCCESS(userInfo)
            this.SET_REFERRER(window.location.href)
            this.$router.push('/modifyDone')
            localStorage.removeItem('url')
          })
      } catch (error) {
        console.log('error :', error);
        console.log('유저 정보 변경 에러에 진입함!')
        if (error.status !== 401) {
          if (error.data.response.message === 'Mail already exists.') {
            this.SET_POPUP(true)
            this.popupSet.content = '중복된 이메일입니다.'
          } else {
            this.SET_POPUP(true)
            this.popupSet.content = errorParser.parse(error)
          }
        } else {
          await this.$router.push('/login')
        }
      } finally {
        this.form.mail.value = ''
        this.form.mail.flag = false
      }
    },
    fnPopup () {
      window.name = 'Parent_window'
      // window.open('', 'popupChk', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no')
      document.form_chk.action = 'https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb'
      document.form_chk.target = 'Parent_window'
      document.form_chk.submit()
      self.close()
    },
    formatPhone (obj) {
      const number = obj.toString().replace(/[^0-9]/g, '')
      let phone = ''
      if (number.length < 4) {
        return number
      }
      if (number.length < 7) {
        phone += number.substr(0, 3)
        phone += '-'
        phone += number.substr(3)
      } else if (number.length < 11) {
        phone += number.substr(0, 3)
        phone += '-'
        phone += number.substr(3, 3)
        phone += '-'
        phone += number.substr(6)
      } else {
        phone += number.substr(0, 3)
        phone += '-'
        phone += number.substr(3, 4)
        phone += '-'
        phone += number.substr(7)
      }
      return phone
    },
    formatPhoneNumber (obj) {
      this.form.tel.value = this.formatPhone(obj)
      return this.form.tel.value
    },
    formatBirth (obj) {
      const number = obj.toString().replace(/[^0-9]/g, '')
      let birth = ''
      if (number.length < 5) {
        return number
      } else if (number.length < 7) {
        birth += number.substr(0, 4)
        birth += '-'
        birth += number.substr(4, 5)
        return birth
      } else {
        birth += number.substr(0, 4)
        birth += '-'
        birth += number.substr(4, 2)
        birth += '-'
        birth += number.substr(6, 2)
        return birth
      }
    },
    formatBirthNumber (obj) {
      this.GET_USERINFO_LIST.birthDate = this.formatBirth(obj)
      return this.GET_USERINFO_LIST.birthDate
    },
    ...mapMutations([
      'SET_MUTATED_USER_INFO',
      'SET_POPUP'
    ]),
    ...mapMutations('identity', [
      'SET_URL',
      'SET_IDENTITY_SUCCESS'
    ]),
    ...mapActions([
      'FETCH_USER_DATA',
      'MODIFY_USER_DATA'
    ]),
    ...mapActions('identity', [
      'IS_TEMP'
    ])
  },
  filters: {
    formatPhone (obj) {
      const number = obj.toString().replace(/[^0-9]/g, '')
      let phone = ''
      if (number.length < 4) {
        return number
      }
      if (number.length < 7) {
        phone += number.substr(0, 3)
        phone += '-'
        phone += number.substr(3)
      } else if (number.length < 11) {
        phone += number.substr(0, 3)
        phone += '-'
        phone += number.substr(3, 3)
        phone += '-'
        phone += number.substr(6)
      } else {
        phone += number.substr(0, 3)
        phone += '-'
        phone += number.substr(3, 4)
        phone += '-'
        phone += number.substr(7)
      }
      return phone
    },
    formatBirth (obj) {
      const number = obj.toString().replace(/[^0-9]/g, '')
      let birth = ''
      if (number.length < 5) {
        return number
      } else if (number.length < 7) {
        birth += number.substr(0, 4)
        birth += '-'
        birth += number.substr(4, 5)
        return birth
      } else {
        birth += number.substr(0, 4)
        birth += '-'
        birth += number.substr(4, 2)
        birth += '-'
        birth += number.substr(6, 2)
        return birth
      }
    }
  },
  beforeDestroy () {
    this.setCount = false
    this.SET_REFERRER('')
    this.SET_POPUP(false)
    /* 본인인증 정보 초기화 */
    const userInfo = {
      name: '',
      birthDate: '',
      gender: '',
      mobileno: '',
      dupInfo: ''
    }
    this.SET_IDENTITY_SUCCESS(userInfo)
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup
  }
}

</script>

<style lang="scss" scoped>
  .separateEmailWrap {
    margin:45px 0 0 0;
  }
  .appContext {
    padding:40px 24px 145px 24px;
    .container {
      padding:0;
      span.warn {
        text-align:right;
        display: block;
        margin: 10px 0 0 0;
      }
    }
  }
</style>
